import script from "./aiMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./aiMenu.vue?vue&type=script&setup=true&lang=js"

import "./aiMenu.vue?vue&type=style&index=0&id=7bc7d19e&lang=scss"

const __exports__ = script;

export default __exports__